/* This constant file contents all the user roll permission key value pair for the Vendor Platform Application */

/* Common for all pages */
export const ROLES = "roles";
export const EDIT = "Edit";
export const VIEW = "View";
export const NONE = "None";
export const ALL = "All";
export const VMP_COMMON_PAGE_ACCESS_ERROR_MSG_PART1 =
  "You are not authorized user to access ";
export const VMP_COMMON_PAGE_ACCESS_ERROR_MSG_PART2 = " page";
export const VMP_PAGEACCESS = "PageAccess";

/* Section Name: CompanyInformation */
/* Page Name: CompanyDetails Page */
export const VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS =
  "VendorPlatform_CompanyInformation_CompanyDetails";
export const VMP_VALIDATE = "Validate";
export const VMP_REVALIDATE = "ReValidate";
export const VMP_ADDMORE = "AddMore";
export const VMP_CONTINUE = "Continue";
export const VMP_COMPANYDETAILS_PAGE_ACCESS_ERROR_MSG =
  "You are not authorized user to access company details page.";
export const VMP_APPROVE_DENY = "ApproveDeny";
export const MINORITYFLAG = "MinorityFlag";

/* Page Name: AddressDetails Page */
export const VENDORPLATFORM_COMPANYINFORMATION_ADDRESSDETAILS =
  "VendorPlatform_CompanyInformation_AddressDetails";
export const VMP_APPLYCHECKBOX = "ApplyCheckBox";
export const VMP_ADDOTHERADDRESS = "AddOtherAddress";
export const VMP_SAVEANDCONTINUE = "SaveAndContinue";
export const VMP_CANCEL_RETURN = "CancelAndReturn";
export const VMP_DELETE_ADDRESS = "DeleteAddress";
export const VMP_ADDRESSDETAILS_PAGE_ACCESS_ERROR_MSG =
  "You are not authorized user to access address details page.";
export const VMP_VENDORPROFILEID_NOT_GENERATED =
  "Please fill up all the details in Company Details page before you fill any details here.";

/* Page Name: ContactDetails Page */
export const VENDORPLATFORM_COMPANYINFORMATION_CONTACTDETAILS =
  "VendorPlatform_CompanyInformation_ContactDetails";
export const VMP_PRIMARYCONTACTCHECKBOX = "PrimaryContactCheckBox";
export const VMP_ADDANOTHERCONTACT = "AddAnotherContact";
export const VMP_PREVIOUS = "Previous";
export const VMP_SUBMIT = "Submit";
export const VMP_CONTACTDETAILS_PAGE_ACCESS_ERROR_MSG =
  "You are not authorized user to access contact details page.";

/* Page Name: MerchantApproval Page */
export const VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL =
  "VendorPlatform_CompanyInformation_MerchantApproval";
export const VMP_DVNRADIO = "DvnRadio";
export const VMP_MANAGEMERCHANTCONTACTS = "ManageMerchantContacts";
export const VMP_ADDHIERARCY = "AddHierarcy";
export const VMP_REQUESTDETAILS = "RequestDetails";
export const VMP_REJECT = "Reject";
export const VMP_MERCHANTAPPROVAL_PAGE_ACCESS_ERROR_MSG =
  "You are not authorized user to access merchand approval page.";
export const VMP_SUBMIT_TO_ACCOUNT_PAYABLE_VP = "SubmitToAccountsPayableVP";
export const VMP_BDSGMMCHIEFMERCHANTAPPROVEBUTTON =
  "BdsGmmChiefMerchantApproveButton";
/* Section Name: PreBoarding */
/* Page Name: DocumentCenter Page */
export const VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER =
  "VendorPlatform_PreBoarding_DocumentCenter";
export const VMP_ADDDOCUMENT = "AddDocument";
export const VMP_GENERATE_CONTRACT = "GenerateContract";
export const VMS_REVIEW_CONSIGNMENT_CONTRACT = "ReviewConsignmentContract";
export const VMS_REVIEW_CONSIGNMENT_CONTRACT_APVP_BUTTON =
  "ReviewConsignmentContractAPVPButton";
export const VMS_REVIEW_CONSIGNMENT_CONTRACT_VENDOR_BUTTON =
  "ReviewConsignmentContractVendorButton";
export const VMS_CONSIGNMENT_FINAL_CONTRACT = "ConsignmentFinalDraft";
export const VMP_ADDDOCUMENT_CONSIGNMENT_CONTRACT_FIRST_DRAFT =
  "AddDocumentConsignmentContractFirstDraft";
export const VMP_ADDDOCUMENT_CHANNEL_PROFIT_CALCULATOR =
  "AddDocumentChannelProfitCalculator";
export const VMP_CANCEL = "Cancel";
export const VMP_UPLOAD = "Upload";
export const VMP_DELETE = "Delete";
export const VMP_W9DELETE = "W9Delete";
export const VMP_W9DOWNLOAD = "W9Download";
export const VMP_DOCUMENTCENTER_PAGE_ACCESS_ERROR_MSG =
  "You are not authorized user to access document center page.";
export const INTEGRATION_INSTRUCTION = "IntegrationInstruction";
export const VMP_GENERATE_BMEWBE_CONTRACT = "GenerateMBEWBEContract";
export const EXPIRATION_DATE = "ExpirationDate";
/**
 * Page name: Vendor OnBoarding Container
 */

export const VENDORPLATFORM_VENDORONBOARDING_ACTION =
  "VendorPlatform_VendorOnBoarding_Action";

export const VMP_ACTION_BUTTON = "ActionButton";
export const VMP_REQUESTMOREDETAILS_VENDOR = "RequestMoreDetailsVendor";
export const VMP_REQUESTMOREDETAILS_MERCHANT = "RequestMoreDetailsMerchant";
export const VMP_RETURNTOMERCHANT = "ReturnToMerchant";
export const VMP_DVNAUDITNOTES = "DVNAuditNotes";
export const VMP_INACTIVE_STATUS = "InactiveStatus";
export const VMP_INTEGRATION_HOLD = "IntegrationHold";
export const VMP_TERMINATE = "Terminate";
export const VMP_INTEGRATION_UNRESPONSIVE = "Unresponsive";
export const VMP_REQUESTMOREDETAILS_CONSIGNMENT_ADMIN =
  "RequestMoreDetailsConsignmentAdmin";
export const VMP_DELETEVENDOR = "DeleteVendor";

/* End of Vendor OnBoarding Container */

/* Page Name: DvnSetUp Page */
export const VENDORPLATFORM_PREBOARDING_DVNSETUP =
  "VendorPlatform_PreBoarding_DvnSetUp";
export const VMP_ADD = "Add";
export const VMP_REMOVE = "Remove";
export const VMP_PRIMARYDVNCHECKBOX = "PrimaryDvnCheckBox";
export const VMP_REQUESTMOREDETAILS = "RequestMoreDetails";
export const VMP_HIERARCHYSELECTION = "HierarchySelection";
export const VMP_APPROVE = "Approve";
export const VMP_ASSIGN_NEW_DVNS_AND_DUNS = "AssignNewDVNsAndDuns";
export const VMP_DVNSETUP_PAGE_ACCESS_ERROR_MSG =
  "You are not authorized user to access DVN setup page.";
export const VMP_BRAND_MAPPING_CHECKBOX = "BrandMappingCheckbox";
export const VMP_BRAND_MAPPING_VIEW_MODIFY_BUTTON =
  "BrandMappingViewModifyButton";
export const VMP_BRANDMAPPING_FIELDS = "BrandMappingFields";
export const VMP_MAINFRAME_ACTION_REQUIRED_MSG = "MainframeActionRequiredMsg";
/* Page Name: DVN Audit Page */
export const VENDORPLATFORM_PREBOARDING_DVNAUDIT =
  "VendorPlatform_PreBoarding_DvnAudit";

/* Page Name: ReviewContract Page */
export const VENDORPLATFORM_PREBOARDING_REVIEWCONTRACT =
  "VendorPlatform_PreBoarding_ReviewContract";
export const VMP_UPDATE = "Update";

/* Page Name: UpsAccount Page */
export const VENDORPLATFORM_PREBOARDING_UPSACCOUNT =
  "VendorPlatform_PreBoarding_UpsAccount";
export const VMP_EDITUPSACCOUNT = "EditUpsAccount";
export const VMP_STANDARDNATIONALHOLIDAYCHECHBOX =
  "StandardNationalHolidayCheckBox";
export const VMP_CALENDARICON = "CalendarIcon";
export const VMP_POPUPCANCEL = "PopUpCancel";
export const VMP_POPUPUPDATE = "PopUpUpdate";

/* Page Name: VendorProfile Page */
export const VENDORPLATFORM_PREBOARDING_VENDORPROFILE =
  "VendorPlatform_PreBoarding_VendorProfile";
export const VMP_SAVE = "Save";
export const VMP_VENDORPROFILE_PAGE_ACCESS_ERROR_MSG =
  "You are not authorized user to access vendor profile page.";
// export const VMP_RETURN_TO_MERCHANT = "ReturnToMerchant";

/* Section Name: Integration */
/* Page Name: PackingSlip Page */
export const VENDORPLATFORM_INTEGRATION_PACKINGSLIP =
  "VendorPlatform_Integration_PackingSlip";

/* Page Name: ShippingLabel Page */
export const VENDORPLATFORM_INTEGRATION_SHIPPINGLABEL =
  "VendorPlatform_Integration_ShippingLabel";

/* Page Name: OrderTesting Page */
export const VENDORPLATFORM_INTEGRATION_ORDERTESTING =
  "VendorPlatform_Integration_OrderTesting";

/* Page Name: 846Testing Page */
export const VENDORPLATFORM_INTEGRATION_846TESTING =
  "VendorPlatform_Integration_846Testing";

/* Page Name: BossAgreement Page */
export const VENDORPLATFORM_INTEGRATION_BOSSAGREEMENT =
  "VendorPlatform_Integration_BossAgreement";

/* Page Name: TableSetUp Page */
export const VENDORPLATFORM_INTEGRATION_TABLESETUP =
  "VendorPlatform_Integration_TableSetUp";

/* Page Name: QualityLeaderApproval Page */
export const VENDORPLATFORM_INTEGRATION_QUALITYLEADERAPPROVAL =
  "VendorPlatform_Integration_QualityLeaderApproval";

/* Page Name: EvpAndErpSetUp Page */
export const VENDORPLATFORM_INTEGRATION_EVPANDERPSETUP =
  "VendorPlatform_Integration_EvpAndErpSetUp";

/* Page Name: ItemSkuSetUp Page */
export const VENDORPLATFORM_INTEGRATION_ITEMSKUSETUP =
  "VendorPlatform_Integration_ItemSkuSetUp";

/* Section Name: Publish */
/* Page Name: CompleteVll Page */
export const VENDORPLATFORM_PUBLISH_COMPLETEVLL =
  "VendorPlatform_Publish_CompleteVll";

/* Page Name: PageCreationComplete Page */
export const VENDORPLATFORM_PUBLISH_PAGECREATIONCOMPLETE =
  "VendorPlatform_Publish_PageCreationComplete";

/* Page Name: OnboardingComplete Page */
export const VENDORPLATFORM_PUBLISH_ONBOARDINGCOMPLETE =
  "VendorPlatform_Publish_OnboardingComplete";

/* Page Name: Live Page */

export const VENDORPLATFORM_PUBLISH_LIVE = "VendorPlatform_Publish_Live";

/* Section Name: MyDashboard */
/* Component Name: MyVendors */
export const VENDORPLATFORM_MYDASHBOARD_MYVENDORS =
  "VendorPlatform_MyDashboard_MyVendors";
/* Component Name: MyTeamBoard */
export const VENDORPLATFORM_MYDASHBOARD_MYTASKS =
  "VendorPlatform_MyDashboard_MyTasks";
export const VENDOR_NAME_NAVIGATION = "VendorNameNavigation";
export const HIDE = "Hide";
export const VMP_NOTEICON = "NoteIcon";
export const VMP_UPDATESTATUS = "UpdateStatus";

export const ACTIONS_CURRENTSTATUS_HIDE = "ActionsCurrentStatusHide";
/* Component Name: Allvendors */
export const VENDORPLATFORM_MYDASHBOARD_ALLVENDORS =
  "VendorPlatform_MyDashboard_AllVendors";
/* Component Name: Preboarding */
export const VENDORPLATFORM_MYDASHBOARD_PREBOARDING =
  "VendorPlatform_MyDashboard_PreBoarding";

/* Component Name: NewVendor */
export const VENDORPLATFORM_MYDASHBOARD_NEWVENDORS =
  "VendorPlatform_MyDashboard_NewVendors";
export const VMP_SELECTDEOPDOWN = "SelectDropdown";
export const VMP_ASSIGN = "Assign";

/* Component Name: AddVendor */
export const VENDORPLATFORM_MYDASHBOARD_ADDVENDOR =
  "VendorPlatform_MyDashboard_AddVendor";
export const VMP_ADDVENDOR = "AddVendor";

/* Component Name: Reports */
export const VENDORPLATFORM_MYDASHBOARD_REPORTS =
  "VendorPlatform_MyDashboard_Reports";
export const VMP_EXPORT = "Export";

/* Component Name: Pipeline */
export const VENDORPLATFORM_MYDASHBOARD_PIPELINE =
  "VendorPlatform_MyDashboard_Pipeline";

/* Page Name: MyTeam; Access Status */
export const VENDORPLATFORM_MYDASHBOARD_MYTEAM =
  "VendorPlatform_MyDashboard_MyTeam";

/* Component Name: AccessRequests */
export const VENDORPLATFORM_MYDASHBOARD_ACCESSREQUESTS =
  "VendorPlatform_MyDashboard_AccessRequests";

/* Component Name: EmailAdmin */
export const VENDORPLATFORM_MYDASHBOARD_EMAILADMIN =
  "VendorPlatform_MyDashboard_EmailAdmin";

/* Component Name: DBMApproval */
export const VENDORPLATFORM_MYDASHBOARD_DBMAPPROVAL =
  "VendorPlatform_MyDashboard_DBMApproval";

/* Component Name: MBEWBEApproval */
export const VENDORPLATFORM_MYDASHBOARD_MBEWBEAPPROVAL =
  "VendorPlatform_MyDashboard_MBEWBEApproval";
/* Component Name: MBEWBEApproval */
export const VENDORPLATFORM_MYDASHBOARD_MBEWBESENDEMAIL =
  "VendorPlatform_MyDashboard_MBEWBESendEmail";

/* Component Name: EmailAdmin */
export const VENDORPLATFORM_MYDASHBOARD_MANAGE_MP_INBOUND =
  "VendorPlatform_MyDashboard_ManageMPInbound";

/* Section Name: MacyHome */
/* Page Name: AllNotifications Page */
export const VENDORPLATFORM_MACYHOME_ALLNOTIFICATIONS =
  "VendorPlatform_MacyHome_AllNotifications";

export const VENDORPLATFORM_MACYHOME_PUBLISH_NOTIFICATIONS =
  "VendorPlatform_MacyHome_Publish_Notification";

/* Page Name: AllResources Page */
export const VENDORPLATFORM_MACYHOME_ALLRESOURCES =
  "VendorPlatform_MacyHome_AllResources";

/* Component Name: GlobalSearch */
export const VENDORPLATFORM_MACYHOME_GLOBALSEARCH =
  "VendorPlatform_MacyHome_GlobalSearch";

/* Component Name: YearFilter */
export const VENDORPLATFORM_MACYHOME_YEARFILTER =
  "VendorPlatform_MacyHome_YearFilter";

/* Section Name: Notes */
/* Component Name: NoteList  */
export const VENDORPLATFORM_NOTES_NOTELIST = "VendorPlatform_Notes_NoteList";
export const VMP_ADDNOTE = "AddNote";
export const VMP_DELETEICON = "DeleteIcon";

export const VENDORPLATFORM_NOTES_RIGHTNOTES =
  "VendorPlatform_Notes_RightNotes";
export const VMP_SIDEBARPANEL = "SideBarPanel";

/* Section Name: Notes */
/* Component Name: NoteList  */
export const VENDORPLATFORM_VENDORONBOARDING_LEFTSIDENAV =
  "VendorPlatform_VendorOnboarding_LeftSideNav";
export const VMP_ONBOARDING_STATUS = "OnboardingStatus";

export const VENDORPLATFORM_VENDORONBOARDING_EXTERNALUSERCHECK =
  "VendorPlatform_VendorOnboarding_ExternalUserCheck";
export const INITIALADDRESSPOPUP = "InitialAddressPopup";
export const EXTUSERENABLED = "ExtUserEnabled";
/* Section Name: MyDashboard */
export const VENDORPLATFORM_MYDASHBOARD_MERCHANTVENDORS =
  "VendorPlatform_MyDashboard_MerchantVendors";

/* Section Name: ShippingLocation */
/* Page Name: Location Page */
export const VENDORPLATFORM_SHIPPING_LOCATIONDETAILS =
  "VendorPlatform_Shipping_LocationDetails";

/* Section Name: Seller Central */
export const VENDORPLATFORM_SELLER_CENTRAL_MANAGE_REPORTS =
  "VendorPlatform_SellerCentral_ManageReports";
export const VENDORPLATFORM_SELLER_CENTRAL_REPORTS =
  "VendorPlatform_SellerCentral_Reports";
  export const VENDORPLATFORM_SELLER_CENTRAL_REPORTS_bkp =
  "VendorPlatform_SellerCentral_Reports_bkp";

/* Section Name: User Management*/
export const VENDORPLATFORM_USERMANAGEMENT_MANAGEUSERS =
  "VendorPlatform_UserManagement_ManageUsers";
export const VENDORPLATFORM_USERMANAGEMENT_ADDUSER =
  "VendorPlatform_UserManagement_AddUser";
export const VENDORPLATFORM_USERMANAGEMENT_PARENTCHILDDUNS =
  "VendorPlatform_UserManagement_ParentChildDuns";
export const VENDORPLATFORM_USERMANAGEMENT_MANAGEUSERS_SEND_EMAIL = "VendorPlatform_UserManagement_ManageUsers_Send_Email";
export const ROUTING_REQUEST_ACCESS =
  "VendorPlatform_Routing_Request_Access";

